import "./ProfileMenu.css";

import { Link } from "react-router-dom";
import React from "react";

const ProfileMenu = ({ active, current }) => {
  return (
    <div className="col col-12 col-md-4">
      <ul className="profile-menu">
        <li className="profile-menu-item">
          <Link
            to="/profile/basic"
            className={active === "basic" ? "active" : ""}
          >
            Basic Information
          </Link>
        </li>
        <li className="profile-menu-item">
          <Link
            to="/profile/personal"
            className={active === "personal" ? "active" : ""}
          >
            Personal Information
          </Link>
        </li>
        <li className="profile-menu-item">
          <Link
            to="/profile/photos"
            className={active === "photos" ? "active" : ""}
          >
            Photos
          </Link>
        </li>
        <li className="profile-menu-item">
          <Link
            to="/profile/location"
            className={active === "location" ? "active" : ""}
          >
            Location
          </Link>
        </li>
        <li className="profile-menu-item">
          <Link
            to="/profile/description"
            className={active === "description" ? "active" : ""}
          >
            Description
          </Link>
        </li>
        {current.accountType === "sugar_baby" && (
          <li className="profile-menu-item">
            <Link
              to="/profile/subscription"
              className={active === "subscription" ? "active" : ""}
            >
              Subscription
            </Link>
          </li>
        )}
      </ul>
      <button className="profile-link">
        <Link to={`/member/${current.name}`}>View my profile</Link>
      </button>
    </div>
  );
};

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/components/ProfileMenu.js